import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useDriverOrderNotifications = (driverId: string) => {
  const { toast } = useToast();

  useEffect(() => {
    if (!driverId) return;

    // Listen for orders assigned to this driver
    const assignmentChannel = supabase
      .channel('driver-order-assignments')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'orders',
          filter: `driver_id=eq.${driverId}`
        },
        async (payload) => {
          console.log('Order assigned to driver:', payload);
          
          if (payload.new && payload.old?.driver_id !== payload.new.driver_id) {
            // This is a new assignment
            toast({
              title: "New Delivery Assigned!",
              description: `New delivery order has been assigned to you.`,
            });
          }

          // Handle status changes for assigned orders
          if (payload.new?.status !== payload.old?.status) {
            const status = payload.new.status;
            let title = '';
            let description = '';

            switch (status) {
              case 'ready_for_pickup':
                title = 'Order Ready for Pickup';
                description = 'Head to the restaurant to collect the order.';
                break;
              case 'cancelled':
                title = 'Order Cancelled';
                description = 'The order has been cancelled.';
                break;
            }

            if (title) {
              toast({ title, description });
            }
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(assignmentChannel);
    };
  }, [driverId, toast]);

  return {
    // Can add methods here if needed
  };
};